import { render, staticRenderFns } from "./OTPVerify.vue?vue&type=template&id=1778bcdc"
import script from "./OTPVerify.vue?vue&type=script&lang=js"
export * from "./OTPVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports